/**
 * Canonical Business Center (seller) paths — flat under `/hub/*`.
 * Legacy `/hub/vendor/*` URLs redirect here (see HubApp).
 */

export const vendorHub = {
  home: '/hub/home',
  analytics: '/hub/analytics',
  orders: '/hub/orders',
  products: '/hub/products',
  productNew: '/hub/products/new',
  productEdit: (id: string) => `/hub/products/${id}/edit`,
  promotions: '/hub/promotions',
  flashSales: '/hub/flash-sales',
  bundles: '/hub/bundles',
  payouts: '/hub/payouts',
  subscription: '/hub/subscription',
  bookings: '/hub/bookings',
  store: '/hub/store',
  seo: '/hub/seo',
  boost: '/hub/boost',
  giftCards: '/hub/gift-cards',
  classifieds: '/hub/classifieds',
  classifiedNew: '/hub/classifieds/new',
  classifiedEdit: (id: string) => `/hub/classifieds/${id}/edit`,
  properties: '/hub/properties',
  propertyNew: '/hub/properties/new',
  propertyEdit: (id: string) => `/hub/properties/${id}/edit`,
  propertyInquiries: '/hub/property-inquiries',
  members: '/hub/members',
  services: '/hub/services',
} as const;

export const proHub = {
  home: '/hub/pro',
  bookings: '/hub/pro/bookings',
  profile: '/hub/pro/profile',
} as const;

/** Map legacy `/hub/vendor` and `/hub/vendor/*` to flat seller paths. */
export function flattenLegacyVendorHubPath(pathname: string): string | null {
  if (pathname === '/hub/vendor' || pathname === '/hub/vendor/') {
    return vendorHub.home;
  }
  if (pathname.startsWith('/hub/vendor/')) {
    return `/hub/${pathname.slice('/hub/vendor/'.length)}`;
  }
  return null;
}

/** True when pathname is a seller (non-admin, non-pro-prefix) hub route. */
export function isSellerHubPath(pathname: string): boolean {
  if (!pathname.startsWith('/hub')) return false;
  if (pathname.startsWith('/hub/admin')) return false;
  if (pathname.startsWith('/hub/pro')) return false;
  return true;
}
